module.exports = __webpack_public_path__ + "static/media/IL.58718920.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/IL.svg
// module id = 276
// module chunks = 0